import styles from './App.module.scss';
import { useLocation } from 'react-router-dom';

import logoImg from './assets/images/logo.png';
import titleImg from './assets/images/title.png';
import screenImg from './assets/images/screen.png';
import { Fragment, useEffect, useRef, useState } from 'react';
import Login from '@components/login';
import { cleanEmailPostfix, getFromLocalStorage, getImgUrl, removeFromLocalStorage } from '@common/util';
import { AuthCacheKey, AuthIdCacheKey, UCUidCacheKey } from './config';
import { getUserInfo, queryDiamondOrderStatus } from '@services/api';
import DiamondNeed from '@components/damdNeed';


const QueryTime = 20
const QueryInterval = 3000

function App() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [ loginVisible, setLoginVisible ] = useState(false);
    const [ userInfoPanelShow, setUserInfoPanelShow ] = useState(false);
    const [ userInfo, setUserInfo ] = useState<any>(null);
    const [showConfirmLogout, toggleConfirmLogout] = useState(false)
    const [showDiamondCharge, setShowDiamondCharge] = useState(false)

    const timerRef = useRef<any>(null);

    // usePageReport();

    useEffect(() => {
        refreshUser();

        const fromScene = searchParams.get('from_scene');
        const payType = searchParams.get('pay_type');
        if( fromScene === 'pay' && payType === 'recharge'){
            const orderId = getFromLocalStorage('_poi')
            if(!!orderId){
                removeFromLocalStorage('_poi')
                checkOrder(orderId);
            }
        }
    },[])

    const checkOrder = (orderId: string) => {
        let time = 0
        timerRef.current = setInterval(() => {
                ++time
                queryDiamondOrderStatus(orderId).then((data: any) => {
                    if (data && data.payStatus === 2) {
                        clearInterval(timerRef.current)
                        timerRef.current = null
                        refreshUser();
                        // toggleSuccessStatus(true)
                        // tryToReportMp('trackCustom', 'payment_successful', { currency: 'USD', value: data.payFee || 0 })
                        // PubSub.publish(EVENT_REFRESH_USER)
                        // router.replace('/')
                    }
                }).catch((e: Error) => { })
                if (time >= QueryTime) {
                    clearInterval(timerRef.current)
                    timerRef.current = null
                }
            }, QueryInterval)
    }

    const refreshUser = () => {
        if (getFromLocalStorage(AuthIdCacheKey) && getFromLocalStorage(AuthCacheKey)) {
            getUserInfo().then((data:any) => {
                const { avatar, contactEmail, diamondInfo, imInfo, nickname, registerTimeMs, subscribeInfo, uid, sex } = data
                setUserInfo({
                    isLogin: true,
                    avatar,
                    contactEmail,
                    diamondInfo,
                    imInfo,
                    nickname,
                    registerTimeMs,
                    subscribeInfo,
                    uid,
                    sex
                })
            }).catch(() => {
                
            })
        }
    }

    const closeConfirmLogout = () => {
        toggleConfirmLogout(false)
    }


    const logoutCallback = () => {
        removeFromLocalStorage(AuthIdCacheKey)
        removeFromLocalStorage(AuthCacheKey)
        removeFromLocalStorage(UCUidCacheKey)
        window.location.reload();
    }


    return (
        <div
            className={styles['app']}
        >
            <div className={styles["content"]}>
                <div className={styles["logo-wrapper"]}>
                    <img alt="logo" src={logoImg} className={styles["logo"]} />
                </div>
                <div className={styles["desc-wrapper"]}>
                    <img alt="desc-content" src={titleImg} className={styles["desc"]} />
                </div>
            </div>
            <div className={styles["footer"]}>
                <p className={styles["subject"]}>TCI ENTERTAINMENT HONGKONG LIMITED</p>
                <p className={styles["contact"]}>Contact Us</p>
                <a target="_blank" href="mailto:contact@yoometapp.com" rel="noreferrer" className={styles["link"]}>
                    <p className={styles["email"]}>Email : contact@yoometapp.com</p>
                </a>
            </div>
            <div className={styles["screen-wrapper"]}>
                <img alt="screen" src={screenImg} className={styles["screen"]} />
            </div>
            <div className={styles["top-user"]}>
                {userInfo ? <Fragment>
                    <div onClick={() => setUserInfoPanelShow(true)} className={styles["user-info"]}>
                        <img className={styles['avatar-img']} alt="avatar" src={getImgUrl(userInfo.avatar)} />
                        <p className={styles['user-nick']}>{userInfo.nickname}</p>
                    </div>
                    <div onClick={() => setShowDiamondCharge(true)} className={styles['user-money']}>
                        <div className={styles['diamond']}>
                            <i className={styles['diamond-i']}></i>
                            <span className={styles['diamond-num']}>{userInfo.diamondInfo?.currencyAmount || 0}</span>
                            <i className={styles['diamond-add']}></i>
                        </div>
                    </div>
                </Fragment>
                :
                <div onClick={() => setLoginVisible(true)} className={styles["login-btn"]}>LOGIN</div>}
            </div>
            {userInfoPanelShow && <div className={styles["user-panel"]}>
                <i className={styles['dialog-close']} onClick={() => setUserInfoPanelShow(false)}></i>
                <div className={styles['dialog-content']}>
                    <div className={styles['user-header']}>
                        <div className={styles['avatar-wrapper']}>
                            <img alt='avatar' className={styles['avatar']} src={getImgUrl(userInfo.avatar) || '/avatar.png'} />
                        </div>
                        <div className={styles['user-header-right']}>
                            <div className={styles['user-name-wrapper']}>
                                <p className={styles['user-name']}>{cleanEmailPostfix(userInfo.nickname)}</p>
                                {userInfo.sex === 2 ? null : <i className={
                                    userInfo.sex === 0 ? styles['user-sex-male'] : styles['user-sex-female']} 
                                />}
                            </div>
                            <p className={styles['user-base-info']}>
                                <span>Email : </span>
                                <span className={styles['highlight']}>{userInfo.registerEmail || userInfo.contactEmail || userInfo.nickname}</span>
                            </p>
                        </div>
                    </div>
                    <div className={styles['options-group']}>
                        <ul>
                            <div>
                                <li className={styles['options-item']} style={{ cursor: 'pointer' }} onClick={() => toggleConfirmLogout(true)}>
                                    <i className={styles['options-logout-icon']}></i>
                                    <span className={styles['options-txt']}>Sign Out</span>
                                    <i className={styles['options-arrow']}></i>
                                </li>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>}
            { showConfirmLogout && <div className="view-port-mask">
                    <div className="dialog">
                        <i className="dialog-close" onClick={closeConfirmLogout}></i>
                        <div className={styles['logout-content']}>
                            <p className="dialog-center-title">Are you sure you want to log out?</p>
                            <div className={styles['logout-btns-wrapper']}>
                                <div className={styles['logout-cancel-wrapper']}>
                                    <button className="dialog-cancel-btn" onClick={closeConfirmLogout}>Cancel</button>
                                </div>
                                <div className={styles['logout-confirm-wrapper']}>
                                    <button className="dialog-btn" onClick={logoutCallback}>Log Out</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {loginVisible && <Login toggleLoginDialog={(v) => setLoginVisible(v)} refreshUser={refreshUser} />}
            {showDiamondCharge && <DiamondNeed userInfo={userInfo} onClose={() => setShowDiamondCharge(false)} lang='en_US'/>}
   
        </div>
    );
}

export default App;
